import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { SupportITPage } from "./pages/SupportITPage";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { InnovaTrackPage } from "./pages/InnovaTrackPage";
import { InnovaPunchPage } from "./pages/InnovaPunchPage";
import { InnovaScenePage } from "./pages/InnovaScenePage";
import { InnovBillPage } from "./pages/InnovBillPage";
import { LogicielsDeploiementPage } from "./pages/LogicielsDeploiementPage";
import { InfrastructureFibreOptiquePage } from "./pages/InfrastructureFibreOptiquePage";
import { ProduitsUbiquitiPage } from "./pages/ProduitsUbiquitiPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/supportit" element={<SupportITPage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/innova-track" element={<InnovaTrackPage />} />
          <Route path="/innova-punch" element={<InnovaPunchPage />} />
          <Route path="/innova-scene" element={<InnovaScenePage />} />
          <Route path="/innov-bill" element={<InnovBillPage />} />
          <Route path="/logiciels-deploiement" element={<LogicielsDeploiementPage />} />
          <Route path="/infrastructure-fibre-optique" element={<InfrastructureFibreOptiquePage />} />
          <Route path="/produits-ubiquiti" element={<ProduitsUbiquitiPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
